<template>
  <div
    v-if="currentAgency"
    ref="convoLeftSidebarRef"
    class="conversation-left-sidebar d-flex flex-column bg-white-custom"
  >
    <div ref="convoLeftSidebarNewRef" class="conversation-left-sidebar--new px-3 pb-3">
      <NewConversationButton />
    </div>
    <div
      ref="convoLeftSidebarTitleRef"
      class="conversation-left-sidebar--title justify-content-center d-flex align-items-center px-3 pb-3"
    >
      <h4>
        <a href="#" @click="reloadLandingPage()">
          {{ showAllConversations ? "All" : "My" }} Conversations
        </a>
      </h4>
      <span class="side-badge badge bg-info align-top">
        {{ activeConversationCount }}
      </span>
    </div>
    <div
      class="conversation-left-sidebar--content"
      :style="{
        height: `${contentHeight}px`
      }"
    >
      <ConversationList />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters, mapState } from "vuex";
import ConversationList from "./conversations/ConversationList";
import NewConversationButton from "@/components/action_buttons/NewConversationButton";

export default {
  name: "ConvoLeftSidebar",
  components: { ConversationList, NewConversationButton },
  data() {
    return {
      contentHeight: 300
    };
  },
  computed: {
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("conversations", ["activeConversationCount"]),
    ...mapGetters("conversations", ["activeConversations"]),
    ...mapGetters("user", ["currentUser", "showAllConversations"]),
    activeConversationCount: function () {
      return this.showAllConversations ? this.activeConversations.length : this.activeConversations.filter(i => i.operator_id === this.currentUser.user_id || i.operator_id === null).length;
    },
    ...mapState({
      feedStatus: (state) => state.agency.feedStatus,
    }),

  },
  created() {
    this.$nextTick(() => {
      if (
        this.$refs.convoLeftSidebarRef &&
        this.$refs.convoLeftSidebarRef.clientHeight &&
        this.$refs.convoLeftSidebarNewRef &&
        this.$refs.convoLeftSidebarNewRef.clientHeight &&
        this.$refs.convoLeftSidebarTitleRef &&
        this.$refs.convoLeftSidebarTitleRef.clientHeight
      ) {
        this.contentHeight = this.$refs.convoLeftSidebarRef.clientHeight
        this.contentHeight -= this.$refs.convoLeftSidebarNewRef.clientHeight;
        this.contentHeight -= this.$refs.convoLeftSidebarTitleRef.clientHeight;
      }
    });
  },
  methods: {
    ...mapActions("conversations", ["fetchConversations"]),
    reloadLandingPage() {
      if (this.currentAgency && this.currentAgency.agency_id)
        this.fetchConversations();

      this.$router.push({ path: "/conversations" }).catch(() => { });
    }
  },
};
</script>

<style lang="scss">
.conversation-left-sidebar {
  width: 100%;
  height: 100%;

  &--title {
    width: 100%;

    h4 {
      margin: 0;
      margin-right: 0.5rem;
      text-transform: uppercase;
    }
  }

  &--content {
    width: 100%;
  }
}
</style>
